import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, Transition as _Transition, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-61d5babc"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "border-b border-r border-gray-300 group relative bg-gray-50 px-3 pt-3 pb-1 text-gray-500",
  style: {"min-height":"7rem"}
}
const _hoisted_2 = { class: "flex items-center justify-between" }
const _hoisted_3 = ["datetime"]
const _hoisted_4 = { class: "flex items-center" }
const _hoisted_5 = {
  key: 0,
  class: "calendar-tooltip-top mr-1.5"
}
const _hoisted_6 = { class: "tooltiptext text-center text-xs" }
const _hoisted_7 = {
  key: 1,
  class: "calendar-tooltip-top mr-1.5"
}
const _hoisted_8 = { class: "text-lg text-red-700" }
const _hoisted_9 = { class: "tooltiptext text-center text-xs" }
const _hoisted_10 = { key: 2 }
const _hoisted_11 = { class: "py-1 divide-y" }
const _hoisted_12 = { class: "ml-2 mt-0.5" }
const _hoisted_13 = {
  key: 0,
  class: "flex w-full justify-center"
}
const _hoisted_14 = ["datetime"]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " - ", -1))
const _hoisted_16 = ["datetime"]
const _hoisted_17 = {
  key: 1,
  class: "flex w-full items-center justify-center"
}
const _hoisted_18 = { class: "flex flex-wrap items-center justify-center" }
const _hoisted_19 = {
  key: 0,
  class: "hidden lg:flex flex-wrap my-1 justify-center px-3 text-gray-500"
}
const _hoisted_20 = {
  key: 1,
  class: "calendar-tooltip-top mr-1.5"
}
const _hoisted_21 = { key: 0 }
const _hoisted_22 = { key: 1 }
const _hoisted_23 = { key: 2 }
const _hoisted_24 = { key: 3 }
const _hoisted_25 = { key: 0 }
const _hoisted_26 = { key: 1 }
const _hoisted_27 = { key: 2 }
const _hoisted_28 = { key: 3 }
const _hoisted_29 = { class: "" }
const _hoisted_30 = { class: "tooltiptext" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FlagIcon = _resolveComponent("FlagIcon")!
  const _component_CheckCircleIcon = _resolveComponent("CheckCircleIcon")!
  const _component_EllipsisVerticalIcon = _resolveComponent("EllipsisVerticalIcon")!
  const _component_MenuButton = _resolveComponent("MenuButton")!
  const _component_TrashIcon = _resolveComponent("TrashIcon")!
  const _component_MenuItem = _resolveComponent("MenuItem")!
  const _component_MenuItems = _resolveComponent("MenuItems")!
  const _component_Menu = _resolveComponent("Menu")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_PlusIcon = _resolveComponent("PlusIcon")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_ExclamationCircleIcon = _resolveComponent("ExclamationCircleIcon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        datetime: _ctx.date,
        class: _normalizeClass([
          _ctx.isToday
            ? 'flex items-center justify-center border-b border-orange font-semibold sm:rounded-full sm:bg-orange-400 sm:text-white'
            : '',
          'h-6 w-6',
        ])
      }, _toDisplayString(_ctx.formatDateToDay(_ctx.date)), 11, _hoisted_3),
      _createElementVNode("div", _hoisted_4, [
        (_ctx.isProjectEnd || _ctx.isProjectStart)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createVNode(_component_FlagIcon, { class: "mt-2r right-0 w-5 text-blue-700" }),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("p", null, _toDisplayString(`${
                  _ctx.isProjectStart
                    ? _ctx.$t("report.planned_project_start")
                    : _ctx.$t("report.planned_project_end")
                } (${_ctx.formatDate(_ctx.date)})`), 1)
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.data.report.status == 'APPROVED')
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createElementVNode("p", _hoisted_8, [
                _createVNode(_component_CheckCircleIcon, { class: "mt-2r right-0 w-5 text-green-400" })
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("p", null, _toDisplayString(_ctx.$t("report.general.approved_at")) + ": " + _toDisplayString(_ctx.formatIsoTimestamp(_ctx.data.report.updated)), 1),
                _createElementVNode("p", null, _toDisplayString(_ctx.$t("report.general.by") + ": " + _ctx.data.report.updated_by), 1)
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.hasReport)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _createVNode(_component_Menu, {
                as: "div",
                class: "inline-block text-left leading-none relative"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_MenuButton, { class: "flex items-center rounded-full text-gray-500" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_EllipsisVerticalIcon, { class: "mt-2r right-0 w-5 text-gray-500" })
                    ]),
                    _: 1
                  }),
                  _createVNode(_Transition, {
                    "enter-active-class": "transition ease-out duration-100",
                    "enter-from-class": "transform opacity-0 scale-95",
                    "enter-to-class": "transform opacity-100 scale-100",
                    "leave-active-class": "transition ease-in duration-75",
                    "leave-from-class": "transform opacity-100 scale-100",
                    "leave-to-class": "transform opacity-0 scale-95"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_MenuItems, { class: "absolute right-5 z-10 mt-2 w-56 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-gray/5 focus:outline-none" }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_11, [
                            _createVNode(_component_MenuItem, {
                              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('deleteReport')))
                            }, {
                              default: _withCtx(({ active }) => [
                                _createElementVNode("a", {
                                  href: "#",
                                  class: _normalizeClass([
                        active ? 'text-red-700' : 'text-gray-700',
                        'group flex items-center px-4 py-2 text-sm',
                      ])
                                }, [
                                  _createVNode(_component_TrashIcon, {
                                    class: _normalizeClass([active ? 'text-red-700' : 'text-gray-700', 'w-4 h-4'])
                                  }, null, 8, ["class"]),
                                  _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.$t("report.delete_report")), 1)
                                ], 2)
                              ]),
                              _: 1
                            })
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    (_ctx.data.report.status !== 'NOT_AVAILABLE')
      ? (_openBlock(), _createBlock(_component_router_link, {
          key: 0,
          to: _ctx.hasReport ? { name: 'SingleDailyReport', params: { date: `${_ctx.date}` } } : '',
          class: "cursor-pointer group my-1.5 flex h-6 w-full items-center justify-center border-l-4 border-gray-300 bg-gray-100 px-3 text-gray-500 hover:bg-yellow-100"
        }, {
          default: _withCtx(() => [
            (_ctx.data.report.site_duration.start_time && _ctx.data.report.site_duration.end_time)
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                  _createElementVNode("div", {
                    datetime: _ctx.data.report.site_duration.start_time,
                    class: "mr-2 hidden xl:block"
                  }, _toDisplayString(_ctx.formatTime(_ctx.data.report.site_duration.start_time)), 9, _hoisted_14),
                  _hoisted_15,
                  _createElementVNode("div", {
                    datetime: _ctx.data.report.site_duration.end_time,
                    class: "ml-2 hidden xl:block"
                  }, _toDisplayString(_ctx.formatTime(_ctx.data.report.site_duration.end_time)), 9, _hoisted_16)
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["to"]))
      : (_openBlock(), _createElementBlock("div", _hoisted_17, [
          _createElementVNode("button", {
            type: "button",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('initializeReport'))),
            class: "cursor-pointer relative inline-flex items-center p-2 border-yellow rounded-full text-yellow-700 hover:bg-yellow-500 hover:text-white focus:outline-none"
          }, [
            _createVNode(_component_PlusIcon, { class: "w-5" })
          ])
        ])),
    _createElementVNode("div", _hoisted_18, [
      (_ctx.holidaysForDate.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.holidaysForDate, (holiday) => {
              return (_openBlock(), _createElementBlock("div", {
                key: holiday.name,
                class: "m-0.5 inline-flex items-center gap-x-1.5 rounded-md px-2 py-1 text-xs font-medium text-blue-700 list-group-item",
                style: _normalizeStyle(
              holiday.type === 'disturbance'
                ? 'background-color: #f5e3be; color: #9c7018'
                : 'background-color: #bfdbfe4c'
            )
              }, _toDisplayString(holiday.name.length > 20 ? `${holiday.name.substring(0, 20)}...` : holiday.name), 5))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      (_ctx.data.weather_warnings.length !== 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
            _createElementVNode("p", {
              class: "text-red",
              onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop","prevent"]))
            }, [
              _createVNode(_component_font_awesome_icon, {
                icon: "fa-solid fa-cloud-bolt",
                class: "h-5"
              })
            ]),
            _createElementVNode("div", {
              class: "tooltiptext text-center text-xs",
              onClick: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["stop","prevent"]))
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data.weather_warnings, (warning) => {
                return (_openBlock(), _createElementBlock("p", {
                  key: warning.value,
                  class: "leading-1 pl-2"
                }, [
                  _createTextVNode(_toDisplayString(_ctx.$t(`report.weather.${warning.type}`)) + ": ", 1),
                  (warning.type == 'wind')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_21, _toDisplayString(warning.value) + " " + _toDisplayString(_ctx.$t(`report.weather.${warning.type}_type`)), 1))
                    : _createCommentVNode("", true),
                  (warning.type == 'cold_temperature')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_22, _toDisplayString(`${warning.min_value} `) + " " + _toDisplayString(_ctx.$t(`report.weather.${warning.type}_type`)) + " (" + _toDisplayString(_ctx.$t(`report.weather.min`)) + ")", 1))
                    : _createCommentVNode("", true),
                  (warning.type == 'hot_temperature')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_23, _toDisplayString(`${warning.max_value} `) + " " + _toDisplayString(_ctx.$t(`report.weather.${warning.type}_type`)) + " (" + _toDisplayString(_ctx.$t(`report.weather.max`)) + ")", 1))
                    : _createCommentVNode("", true),
                  (warning.type == 'precipitation')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_24, [
                        (
                    warning.rule.time_period == '7/7-14' &&
                    warning.rule.duration_operator == 'ENTIRE_TIME_PERIOD'
                  )
                          ? (_openBlock(), _createElementBlock("span", _hoisted_25, _toDisplayString(`${warning.value} ${warning.rule.volume_unit} (07:00 - 14:00)`), 1))
                          : _createCommentVNode("", true),
                        (warning.rule.time_period == '24/7-7')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_26, _toDisplayString(`${warning.value} ${warning.rule.volume_unit} (24h)`), 1))
                          : _createCommentVNode("", true),
                        (warning.rule.duration_operator == '>=' && warning.rule.volume_unit == 'mm')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_27, _toDisplayString(`${warning.value} ${warning.rule.volume_unit}`) + " (" + _toDisplayString(_ctx.formatTime(warning.start_time)) + "-" + _toDisplayString(_ctx.formatTime(warning.end_time)) + ")", 1))
                          : _createCommentVNode("", true),
                        (
                    warning.rule.duration_operator == '>=' && warning.rule.volume_unit == 'mm/h'
                  )
                          ? (_openBlock(), _createElementBlock("span", _hoisted_28, _toDisplayString(`>= ${warning.rule.volume_value} ${warning.rule.volume_unit}`) + " (" + _toDisplayString(_ctx.formatTime(warning.start_time)) + "-" + _toDisplayString(_ctx.formatTime(warning.end_time)) + ")", 1))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true)
                ]))
              }), 128))
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.data.report.special_events.length)
        ? (_openBlock(), _createElementBlock("div", {
            key: 2,
            class: "calendar-tooltip-top",
            onClick: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["stop","prevent"]))
          }, [
            _createElementVNode("p", _hoisted_29, [
              _createVNode(_component_ExclamationCircleIcon, { class: "h-6 text-yellow" })
            ]),
            _createElementVNode("div", _hoisted_30, [
              _createElementVNode("ul", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data.report.special_events, (event) => {
                  return (_openBlock(), _createElementBlock("li", {
                    class: "mx-0.5 my-0.5 truncate rounded px-1 text-xs",
                    key: event.special_events_type.value
                  }, _toDisplayString(event.special_events_type.mode === "default"
                  ? _ctx.$t(
                      `report.sections.special_events.special_events_type_entries.${event.special_events_type.value}`,
                    )
                  : event.special_events_type.value), 1))
                }), 128))
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}